import { useForm } from 'react-hook-form';
import { Link, useNavigate } from 'react-router-dom';
import { useLogin } from '../hooks/useAuth';

interface LoginForm {
  email: string;
  password: string;
}

export function LoginPage() {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<LoginForm>();
  const login = useLogin();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center px-4">
      <form
        onSubmit={handleSubmit((data) => login.mutate(data, { onSuccess: () => navigate('/app') }))}
        className="w-full max-w-sm bg-white p-8 rounded shadow"
      >
        <h1 className="text-2xl font-bold mb-6">Log in</h1>

        <label className="block mb-3">
          <span className="text-sm font-medium">Email</span>
          <input
            type="email"
            className="mt-1 w-full border rounded px-3 py-2"
            {...register('email', { required: true })}
          />
          {errors.email && <span className="text-xs text-red-600">Required</span>}
        </label>

        <label className="block mb-4">
          <span className="text-sm font-medium">Password</span>
          <input
            type="password"
            className="mt-1 w-full border rounded px-3 py-2"
            {...register('password', { required: true })}
          />
          {errors.password && <span className="text-xs text-red-600">Required</span>}
        </label>

        {login.error && <div className="mb-3 text-sm text-red-600">{(login.error as Error).message}</div>}

        <button
          type="submit"
          disabled={login.isPending}
          className="w-full bg-gray-900 text-white py-2 rounded hover:bg-gray-800 disabled:opacity-50"
        >
          {login.isPending ? 'Signing in…' : 'Log in'}
        </button>

        <p className="text-sm text-gray-600 mt-4">
          No account?{' '}
          <Link to="/signup" className="underline">
            Sign up
          </Link>
        </p>
      </form>
    </div>
  );
}
